module.exports = __webpack_public_path__ + "static/media/refinery.a5240a15.png";